import { useNavigate, useParams } from "react-router-dom";
import { axiosBase } from "../api/fetchWrapper";
import { useEffect, useState } from "react";
import { displayMessage } from "../helper/tools";
import Icon from "../components/common/Icon";


const PASSWORD_PATTERN = "(?=.*[a-z])(?=.*[A-Z])(?=.*\\d)(?=.*[@$!%*?&])[A-Za-z\\d@$!%*?&]{8,}";
const PASSWORD_REGEX = new RegExp(`^${PASSWORD_PATTERN}$`);
const PASSWORD_RULES_MESSAGE = "Le mot de passe doit contenir au moins 8 caractères, une majuscule, " +
    "une minuscule, un chiffre et un caractère spécial (parmi : @$!%*?&).";

export default function PasswordRecovery() {
    const navigate = useNavigate()
    const { email } = useParams()
    const { token } = useParams()
    const [message, setMessage] = useState({ text: "", type: "" })
    const [showPassword, setShowPassword] = useState(false)
    const [showPasswordConfirm, setShowPasswordConfirm] = useState(false)
    const [passwordError, setPasswordError] = useState("")
    const goback = () => {
        navigate("/pro/login")
    }
    const CHANGE_PASSWORD_URL = '/api-v1/user/password/reset';

    const handleSubmit = async (e) => {
        e.preventDefault()
        let password = document.getElementById("password").value;
        let passwordConfirm = document.getElementById("passwordConfirm").value;
        if (!PASSWORD_REGEX.test(password)) {
            return
        }
        if (password !== passwordConfirm) {
            setPasswordError("Les mots de passe ne correspondent pas.")
            return
        }
        setPasswordError("")
        localStorage.clear();
        const response = await axiosBase.post(
            CHANGE_PASSWORD_URL,
            { password, passwordConfirm, email, token },
            {
                headers: {
                    "Content-Type": "application/json"
                }
            }
        ).then(response => {
            if (!response?.data?.error) {
                setMessage({
                    text: `${response?.data?.message}`,
                    type: "success"
                })
            } else {
                setMessage({
                    text: `${response?.data?.error}`,
                    type: "error"
                })
            }
        })
    }

    useEffect(() => {
        if (message) {
            displayMessage(message)
        }
    }, [message]);

    const checkTokenValidity = async (email, token) => {
        const response = await axiosBase.post(
            '/api-v1/user/password/token/validity',
            { email, token },
            {
                headers: {
                    "Content-Type": "application/json"
                }
            }
        ).then(response => {
            if (response?.data?.error) {
                setMessage({
                    text: "Le lien de récupération de mot de passe n'est pas valide. " +
                        "(Vous avez peut-être déjà utilisé ce lien, ou il a expiré. " +
                        "Veuillez refaire une demande de récupération de mot de passe)",
                    type: "error"
                })
            } else {
                setMessage({ text: "Le lien de récupération de mot de passe est valide", type: "success" })
            }
        })
    }


    useEffect(() => {
        document.title = "Récupération de mot de passe - Obsèques en France";
        if (!email || !token) {
            navigate("/pro/login")
        } else if (email && token) {
            checkTokenValidity(email, token)
        }
    }, [email, token]);

    return (
        <main className="column">
            {(email && token && message?.type != "") &&
                <>
                    <header>
                        <h1 className="header-title">Page de récupération de mot de passe</h1>
                    </header>
                    <div className="static-page">
                        <fieldset>
                            <Icon span="Changer mon mot de passe" source={"fa fa-user-lock"} />
                            {(message?.text === "Le lien de récupération de mot de passe est valide") &&
                                <>
                                    <div className="form-input">
                                        <label htmlFor="password">Nouveau mot de passe</label>
                                        <div className="password-input-wrapper">
                                            <input type={showPassword ? "text" : "password"} name="password" id="password" pattern={PASSWORD_PATTERN} required />
                                            <i
                                                className={showPassword ? "fa fa-eye password-toggle-icon" : "fa fa-eye-slash password-toggle-icon"}
                                                onClick={() => setShowPassword(!showPassword)}
                                            />
                                        </div>
                                    </div>
                                    <div className="form-input">
                                        <label htmlFor="passwordConfirm">Confirmer le mot de passe</label>
                                        <div className="password-input-wrapper">
                                            <input type={showPasswordConfirm ? "text" : "password"} name="passwordConfirm" id="passwordConfirm" pattern={PASSWORD_PATTERN} required />
                                            <i
                                                className={showPasswordConfirm ? "fa fa-eye password-toggle-icon" : "fa fa-eye-slash password-toggle-icon"}
                                                onClick={() => setShowPasswordConfirm(!showPasswordConfirm)}
                                            />
                                        </div>
                                    </div>
                                    {passwordError &&
                                        <p className="error">{passwordError}</p>
                                    }
                                </>
                            }
                            {(message?.text !== "Le lien de récupération de mot de passe est valide") &&
                                <div className="message"></div>
                            }
                            <div className="buttons-container space-between">
                                <button type="button" className="red-button" onClick={goback}><i className="fa fa-arrow-left" /><span>Retour</span></button>
                                {(message?.text === "Le lien de récupération de mot de passe est valide") &&
                                    <button type="button" className="green-button" onClick={handleSubmit}><i className="fa fa-check" /><span>Envoyer</span></button>
                                }
                            </div>
                            {(message?.text === "Le lien de récupération de mot de passe est valide") &&
                                <p className="error">{PASSWORD_RULES_MESSAGE}</p>
                            }
                        </fieldset>
                    </div>
                </>
            }
        </main>
    )
}